/* TORMINT / Obsidian theme scripts */
(function(){
  'use strict';

  /* ---- Header scroll state ---- */
  var header = document.querySelector('.site-header');
  var headerGroup = document.querySelector('[data-header-group]');
  function onScroll(){
    var scrolled = window.scrollY > 20;
    if(header){ header.classList.toggle('is-scrolled', scrolled); }
    if(headerGroup){ headerGroup.classList.toggle('is-scrolled', scrolled); }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  /* ---- Measure stacked header height for accurate hero overlay offset ---- */
  function setHeaderHeight(){
    if(!headerGroup) return;
    var h = headerGroup.offsetHeight;
    if(h){ document.documentElement.style.setProperty('--header-stack-h', h + 'px'); }
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, {passive:true});
  window.addEventListener('load', setHeaderHeight);

  /* ---- Mobile menu ---- */
  var mToggle = document.querySelector('[data-menu-open]');
  var mMenu = document.querySelector('.mobile-menu');
  var mClose = document.querySelector('[data-menu-close]');
  if(mToggle && mMenu){
    mToggle.addEventListener('click', function(){ mMenu.classList.add('is-open'); document.body.style.overflow='hidden'; });
  }
  if(mClose && mMenu){
    mClose.addEventListener('click', function(){ mMenu.classList.remove('is-open'); document.body.style.overflow=''; });
  }

  /* ---- Reveal on scroll ---- */
  var reveals = document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window && reveals.length){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, {threshold:0.12});
    reveals.forEach(function(el){ io.observe(el); });
  } else {
    reveals.forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* ---- Cart drawer ---- */
  var overlay = document.querySelector('.drawer-overlay');
  var drawer = document.querySelector('.cart-drawer');
  function openCart(){ if(drawer){drawer.classList.add('is-open'); overlay&&overlay.classList.add('is-open'); document.body.style.overflow='hidden'; refreshCart();} }
  function closeCart(){ if(drawer){drawer.classList.remove('is-open'); overlay&&overlay.classList.remove('is-open'); document.body.style.overflow='';} }
  document.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openCart(); }); });
  document.querySelectorAll('[data-cart-close]').forEach(function(b){ b.addEventListener('click', closeCart); });
  if(overlay){ overlay.addEventListener('click', closeCart); }

  var moneyFmt = window.TormintShopMoneyFormat || '${{amount}}';
  function formatMoney(cents){
    var val = (cents/100).toFixed(2);
    return moneyFmt.replace(/\{\{\s*amount\s*\}\}/, val.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  var FREE_SHIP = (window.TormintFreeShipThreshold || 0); // cents, 0 disables

  function refreshCart(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(renderCart).catch(function(){});
  }
  function renderCart(cart){
    var itemsEl = document.querySelector('.cart-drawer__items');
    var totalEl = document.querySelector('[data-cart-total]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function(c){ c.textContent = cart.item_count; c.style.display = cart.item_count>0?'flex':'none'; });
    if(totalEl){ totalEl.textContent = formatMoney(cart.total_price); }

    // free shipping progress
    var prog = document.querySelector('[data-ship-progress]');
    var bar = document.querySelector('.progress-fill');
    if(prog && FREE_SHIP>0){
      if(cart.total_price >= FREE_SHIP){ prog.innerHTML = 'You have unlocked <strong style="color:var(--molten-bright)">complimentary insured shipping.</strong>'; }
      else{ prog.innerHTML = 'Spend <strong style="color:var(--molten-bright)">'+formatMoney(FREE_SHIP-cart.total_price)+'</strong> more for complimentary insured shipping.'; }
      if(bar){ bar.style.width = Math.min(100, (cart.total_price/FREE_SHIP)*100)+'%'; }
    }

    if(!itemsEl) return;
    if(cart.item_count===0){
      itemsEl.innerHTML = '<div class="cart-empty"><p>Your vault is empty.</p><a href="/collections/all" class="btn btn--gold">Explore the Collection</a></div>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function(it){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2') : '';
      return '<div class="cart-item" data-key="'+it.key+'">'+
        '<img src="'+img+'" alt="'+it.product_title+'" width="72" height="72" loading="lazy">'+
        '<div><div class="cart-item__title">'+it.product_title+'</div>'+
        (it.variant_title && it.variant_title!=='Default Title' ? '<div class="cart-item__meta">'+it.variant_title+'</div>':'')+
        '<div class="cart-item__meta">Qty '+it.quantity+'</div>'+
        '<button class="cart-item__remove" data-remove="'+it.key+'" style="color:var(--pewter);font-size:.72rem;letter-spacing:.1em;text-transform:uppercase;margin-top:6px">Remove</button></div>'+
        '<div class="cart-item__title" style="font-size:1rem">'+formatMoney(it.final_line_price)+'</div>'+
      '</div>';
    }).join('');
    itemsEl.querySelectorAll('[data-remove]').forEach(function(btn){
      btn.addEventListener('click', function(){ changeItem(btn.getAttribute('data-remove'), 0); });
    });
  }
  function changeItem(key, qty){
    fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(renderCart);
  }

  /* ---- AJAX add to cart ---- */
  document.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.textContent : '';
      if(btn){ btn.textContent = 'Adding...'; btn.disabled = true; }
      fetch('/cart/add.js', {method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){return r.json();})
        .then(function(){ if(btn){btn.textContent=orig;btn.disabled=false;} openCart(); })
        .catch(function(){ if(btn){btn.textContent=orig;btn.disabled=false;} form.submit(); });
    });
  });

  /* ---- Product gallery ---- */
  var mainImg = document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      if(!mainImg) return;
      mainImg.src = t.getAttribute('data-full');
      document.querySelectorAll('[data-gallery-thumb]').forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
    });
  });

  /* ---- Qty stepper ---- */
  document.querySelectorAll('.qty').forEach(function(q){
    var input = q.querySelector('input');
    q.querySelector('[data-qty-minus]').addEventListener('click', function(){ input.value = Math.max(1, parseInt(input.value||1)-1); });
    q.querySelector('[data-qty-plus]').addEventListener('click', function(){ input.value = parseInt(input.value||1)+1; });
  });

  /* ---- Variant pills (demo / single-product) ---- */
  document.querySelectorAll('[data-variant-group]').forEach(function(group){
    group.querySelectorAll('.variant-pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        group.querySelectorAll('.variant-pill').forEach(function(p){p.classList.remove('is-active');});
        pill.classList.add('is-active');
        var input = document.querySelector('[name="id"]');
        if(input && pill.getAttribute('data-variant-id')){ input.value = pill.getAttribute('data-variant-id'); }
        var priceEl = document.querySelector('[data-price]');
        if(priceEl && pill.getAttribute('data-price')){ priceEl.textContent = pill.getAttribute('data-price'); }
      });
    });
  });

  refreshCart();
})();
